import React, {useContext, useEffect, useState} from 'react';
import {useZooPassAppContext} from "./Context/ZooPassAppContext";
import Collapse from 'react-bootstrap/Collapse'
import classNames from 'classnames';
import {IZooPassAnswersContext, ZooPassAnswersState, ZooPassAppAnswersContext} from "./Context/ZooPassAnswersContext";
import {Step2Panel} from "./Components/Panel/Step2Panel";
import {Step3Panel} from "./Components/Panel/Step3Panel";
import {Step1Panel} from "./Components/Panel/Step1Panel";
import {Step4Panel} from "./Components/Panel/Step4Panel";
import {Step5Panel} from "./Components/Panel/Step5Panel";
import {SidebarStepItem} from "./Components/SidebarStepItem";
import {Step1SidebarValue} from "./Components/SidebarStepValue/Step1SidebarValue";
import {Step2SidebarValue} from "./Components/SidebarStepValue/Step2SidebarValue";
import {Step3SidebarValue} from "./Components/SidebarStepValue/Step3SidebarValue";
import {Step4SidebarValue} from "./Components/SidebarStepValue/Step4SidebarValue";
import {Step5SidebarValue} from "./Components/SidebarStepValue/Step5SidebarValue";
import {Step7Panel} from "./Components/Panel/Step7Panel";
import {Step8Panel} from "./Components/Panel/Step8Panel";
import {Step7SidebarValue} from "./Components/SidebarStepValue/Step7SidebarValue";
import {Step8SidebarValue} from "./Components/SidebarStepValue/Step8SidebarValue";
import {Step9Panel} from "./Components/Panel/Step9Panel";
import {Step2RenewalPanel} from "./Components/Panel/Step2RenewalPanel";
import {Step2GuestRenewalPanel} from "./Components/Panel/Step2GuestRenewalPanel";

const ZooPassApp: React.FC = () => {
    let {
        dictionary,
        headerAnswers,
        imageAnswers,
        numericValues,
        summaryTranslations,
        textTitles,
        loading,
        error
    } = useZooPassAppContext();
    
    let {
        answersData,
        answersLoading
    } = useContext<IZooPassAnswersContext>(ZooPassAppAnswersContext);

    if (loading || answersLoading) {
        //"width: 3rem; height: 3rem;"
        return <div className="m-4 d-flex justify-content-center"> 
        <div className="spinner-border" style={{width: '3rem', height: '3rem'}} role="status">
            <span className="sr-only">Loading...</span>
        </div></div>;
    }

    if (error) {
        return <div className="m-4 d-flex justify-content-center">
            <div className="alert alert-danger w-75" role="alert">
                {error}
            </div>
        </div>;
    }

    const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);
    const [isOpen, setIsOpen] = useState(isDesktop);
    const [stylePercentValue, setStylePercentValue] = useState("0%");

    useEffect(() => {
        const handleResize = () => {
            const desktop = window.innerWidth >= 768;
            setIsDesktop(desktop);
            setIsOpen(desktop); // Set open state based on screen size
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    
    useEffect(() => {
        if(answersData == null || answersLoading) {
            setStylePercentValue("0%");
            return;
        }
        // Step 6 (parking) is no longer shown; keep internal step numbers but compute progress using 8 visible steps.
        const internalStep = answersData.step;
        const visibleStep = internalStep >= 7 ? internalStep - 1 : internalStep;
        const step0 = visibleStep - 1;
        const perc = (step0 / 8) * 100;
        setStylePercentValue(perc + "%");
    },[answersData?.step])
    
    // useEffect(() => {
    //     if(answersData == null || answersLoading) return;
    //     if(answersData.step8IdValue == null) return;
    //     if(answersData.step != 9) return;
    //     window.location.href = "https://zsom-tnew-test.tnhs.cloud/donate/i/" + answersData.step8IdValue;
    // },[answersData?.step8IdValue, answersData?.step]);

    const toggleCollapse = () => {
        if (!isDesktop) {
            setIsOpen(!isOpen);
        }
    };
    
    return <div className="row text-black zoopass__wrapper">
        <div className="col-12 col-md-4 col-lg-3 col-xl-2 order-md-2 progress__wrapper"><div className="w-100">
            <h4>{dictionary.get("ZooPass:Progress:00:Title")}</h4>
            <div className="progress__bar mb-2">
                <div className="progress__bar--progress progress" role="progressbar" aria-label="Step Progress" aria-valuenow={(() => {
                    const step = answersData?.step ?? 1;
                    const visibleStep = step >= 7 ? step - 1 : step;
                    return visibleStep - 1;
                })()} aria-valuemin={0} aria-valuemax={8}>
                    <div className="progress-bar" style={{"width":stylePercentValue}}></div>
                </div>
            </div>
            <div>
            <h5 className="mb-0 d-none d-md-block" style={{cursor: isDesktop ? 'default' : 'pointer'}}>
                    {dictionary.get("ZooPass:Progress:00:Subtitle")}
                </h5>
                <h5 onClick={toggleCollapse} className="mb-0 d-flex d-md-none" style={{cursor: isDesktop ? 'default' : 'pointer'}}>
                    <span className="">{dictionary.get("ZooPass:Progress:00:SubtitleMobile")}</span>
                    <svg width="12" height="12" viewBox="0 0 24 14" xmlns="http://www.w3.org/2000/svg" className={classNames({"svg-open": isOpen})}>
                        <path d="M22.826 0a1.088 1.088 0 00-.767.322l-10.103 9.763L1.853.322A1.088 1.088 0 10.342 1.885L11.2 12.38c.421.407 1.09.407 1.512 0L23.569 1.883v.001a1.088 1.088 0 00-.743-1.884V0z"
                        fill="#1D1719" fill-rule="nonzero"></path>
                    </svg>
                    
                </h5>
                <Collapse in={isOpen}>
                    <div className="w-100 row-cols-1">
                        <SidebarStepItem sidebarStep={1} key="sidebarItem1"
                                         label={dictionary.get("ZooPass:Progress:01:Title") ?? ""}>
                            <Step1SidebarValue/>
                        </SidebarStepItem>
                        <SidebarStepItem sidebarStep={2} key="sidebarItem2"
                                         label={dictionary.get("ZooPass:Progress:02:Title") ?? ""}>
                            <Step2SidebarValue/>
                        </SidebarStepItem>
                        <SidebarStepItem sidebarStep={3} key="sidebarItem3"
                                         label={dictionary.get("ZooPass:Progress:03:Title") ?? ""}>
                            <Step3SidebarValue/>
                        </SidebarStepItem>
                        <SidebarStepItem sidebarStep={4} key="sidebarItem4"
                                         label={dictionary.get("ZooPass:Progress:04:Title") ?? ""}>
                            <Step4SidebarValue/>
                        </SidebarStepItem>
                        <SidebarStepItem sidebarStep={5} key="sidebarItem5"
                                         label={dictionary.get("ZooPass:Progress:05:Title") ?? ""}>
                            <Step5SidebarValue/>
                        </SidebarStepItem>
                        <SidebarStepItem sidebarStep={7} key="sidebarItem7"
                                         label={dictionary.get("ZooPass:Progress:07:Title") ?? ""}>
                            <Step7SidebarValue/>
                        </SidebarStepItem>
                        <SidebarStepItem sidebarStep={8} key="sidebarItem8"
                                         label={dictionary.get("ZooPass:Progress:08:Title") ?? ""}>
                            <Step8SidebarValue/>
                        </SidebarStepItem>
                        <SidebarStepItem sidebarStep={9} key="sidebarItem9"
                                         label={dictionary.get("ZooPass:Progress:09:Title") ?? ""}>
                            <></>
                        </SidebarStepItem>
                    </div>
                </Collapse>
            </div>


        </div>
        </div>
        <div className="col-12 col-md-8 col-lg-9 col-xl-10 order-md-1 zoopass__detail_wrapper">
            <Step1Panel/>
            <Step2Panel/>
            <Step2RenewalPanel/>
            <Step2GuestRenewalPanel/>
            <Step3Panel/>
            <Step4Panel/>
            <Step5Panel/>
            <Step7Panel/>
            <Step8Panel/>
            <Step9Panel/>
        </div>
    </div>
}
export default ZooPassApp;